import { OrderStateV2 } from '../context';

import { CreateOrderPayloadV2 } from './types';

export const buildCreatePayload = (
  state: OrderStateV2,
): CreateOrderPayloadV2 => ({
  account_id: state.billingAccount?.id || 0,
  order_type: (state.orderType || 'GIG') as 'GIG' | 'LTA',
  verification_enabled: !!state.verificationEnabled,
  jobs: state.jobs.map((job) => ({
    ...job,
    job_type: state.orderType || job.job_type,
  })),
});
